 export default class FontSizer {
 	constructor() {
    const change_font = document.querySelector('.change-font');
    if(change_font) {
    	this.initFontSizer();
    }
    
    }
    
    initFontSizer() {
    	// font size switcher
    	document.querySelector('.change-font').addEventListener('click', function(e) {
        // Find the closest 'a' tag relative to the click target
        const targetLink = e.target.closest('a');

        // If the click wasn't on or inside an 'a' tag, do nothing
        if (!targetLink) return;

        e.preventDefault();

        // Remove 'active' class from all matching links
        document.querySelectorAll('.change-font a.size').forEach(el => {
          el.classList.remove('active');
        });

        // Add 'active' class to the clicked link
        targetLink.classList.add('active');

        const body = document.body;

        // Handle body class changes based on the clicked link's classes
        if (targetLink.classList.contains('font-size-1')) {
          body.classList.remove('text-size2', 'text-size3');
        } else if (targetLink.classList.contains('font-size-2')) {
          body.classList.remove('text-size3');
          body.classList.add('text-size2');
        } else if (targetLink.classList.contains('font-size-3')) {
          body.classList.remove('text-size2');
          body.classList.add('text-size3');
        }
      });
    }	
 }